import queryKeys from '@/constants/queryKeys';
import { toggleNotificationReadStatus } from '@/services/api/requests/notifications';
import { TNotification } from '@/types/Notification.types';
import { useMutation } from '@tanstack/react-query';

const useReadNotification = (notification: TNotification) => {
  const { mutate, data, isError, error } = useMutation({
    mutationKey: [queryKeys.notifications.toggleReadSingle],
    mutationFn: async ({
      notificationId,
      onSuccessCallback,
    }: {
      notificationId: string;
      onSuccessCallback?: ((notification: TNotification) => void) | undefined;
    }) => {
      await toggleNotificationReadStatus(notificationId, true);

      return onSuccessCallback;
    },
    onSuccess: (onSuccessCallback: ((notification: TNotification) => void) | undefined) => {
      onSuccessCallback?.(notification);
    },
  });

  return { mutate, data, isError, error };
};

export default useReadNotification;
